import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import {
  GET_USER_DETAILS_REQUEST,
  UPDATE_USER_STATUS_BY_USER_ID_REQUEST,
} from "./actionTypes";
import {
  getUserDetailsResponse,
  updateUserStatusByUserIdResponse,
} from "./actions";
import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";

function* getUserDetails() {
  try {
    const response = yield call(invokeApi, "get", "/UserMgmt", "");
    yield put(getUserDetailsResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateUserStatusByUserId({ payload: { userId, status } }) {
  try {
    const response = yield call(
      invokeApi,
      "patch",
      "/UserMgmt/" + userId + "/" + status,
      {}
    );
    yield put(updateUserStatusByUserIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchUserMgmt() {
  yield takeEvery(GET_USER_DETAILS_REQUEST, getUserDetails);
  yield takeEvery(
    UPDATE_USER_STATUS_BY_USER_ID_REQUEST,
    updateUserStatusByUserId
  );
}

function* userMgmtSaga() {
  yield all([fork(watchUserMgmt)]);
}

export default userMgmtSaga;
